import { render } from "./PrePostApprovalLayout.vue?vue&type=template&id=027fb4f7"
import script from "./PrePostApprovalLayout.vue?vue&type=script&lang=js"
export * from "./PrePostApprovalLayout.vue?vue&type=script&lang=js"

import "./PrePostApprovalLayout.vue?vue&type=style&index=0&id=027fb4f7&lang=scss"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__